import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import Triangulr from 'triangulr';
import tinyColor from 'tinycolor2';
import { useResize, solitude, spaceCadet } from '@phishtool/ui';
import { StyledWrapper } from './styled';
const easeInQuad = (x) => Math.pow(x, 4);
const getRandom = (min, max) => Math.random() * (max - min) + min;
const colorRenderMap = {
    light: (path) => {
        const ratio = (path.x + path.y) / (path.cols + path.lines);
        const eased = easeInQuad(ratio) * 100;
        const min = 0 + eased;
        const max = 5 + eased;
        return tinyColor(solitude).darken(getRandom(min, max)).toString();
    },
    dark: (path) => {
        const ratio = (path.x + path.y) / (path.cols + path.lines);
        const eased = easeInQuad(ratio) * 30;
        const min = 0 + eased;
        const max = 5 + eased;
        return tinyColor(spaceCadet).lighten(getRandom(min, max)).toString();
    },
};
const Pattern = ({ type = 'light' }) => {
    const ref = useRef(null);
    const dimensions = useResize();
    const colorRender = colorRenderMap[type];
    useEffect(() => {
        if (ref.current) {
            const svg = new Triangulr(ref.current.clientWidth, ref.current.clientHeight * 1.5, 100, 50, colorRender);
            ref.current.innerHTML = '';
            ref.current.appendChild(svg);
        }
    }, [ref, dimensions]);
    return _jsx(StyledWrapper, { ref: ref, type: type });
};
export default Pattern;
